import swal from "sweetalert2";

export async function confirmUnsavedChangesWillBeLost() {
	try {
		const result = await swal.fire({
			title: "Changes will be lost on deletion",
			html: "Your changes will be lost.  Are you sure you wish to proceed?",

			showCloseButton: true,
			type: "warning",
			showCancelButton: true,
			confirmButtonColor: "#8CC541",
			confirmButtonText: "Confirm"
		});

		return !result.dismiss;
	}catch(error) {		
		return false;
	}
}